/**
 *
 * @description 解約理由を読点区切りの文字列から配列に変換する
 *
 * @param value {string}
 * @returns Array<String>
 */
export const fromReasonToArrayConverter = (value: string) => {
	return value.split(", ").filter((value) => value.trim().length > 0);
};
